import { useGetPartnersListQuery } from 'domains/Configurations/Users/usersApi';

function usePartnersList(skipCache = false) {
  return useGetPartnersListQuery({}, { skip: skipCache });
}

export default usePartnersList;
